@if (hasValueToDisplay) {
  @if (prettyValue) {
    <span [class.positive]="isPositive" [class.negative]="!isPositive">
      ({{ prettyValue }})
    </span>
  } @else {
    (=)
  }
}
